import { Api } from './Api';

const getAll = async () => {
    try {
        const { data } = await Api.get('/api/categories/');
        return data;
    } catch (error) {
        return new Error(error?.response?.data?.message || 'Erro ao listar categorias');
    }
};

export const CategoriesService = { getAll };
